import { Flex, useBoolean } from "@chakra-ui/react";
import {
  getInvestmentWizardRoute,
  IconButton,
  Trash2Icon,
} from "@verivest/shared-components";
import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../..";
import { CancelInvestmentModal } from "../white-label/manager/investments/CancelInvestmentModal";
import { PendingInvestmentCardProps } from "./horizontal-cards.types";
import { InvestmentCard } from "./InvestmentCard";

export const PendingInvestmentCard: React.FC<PendingInvestmentCardProps> = ({
  refresh,
  actionIsRequired,
  isDeletable,
  children,
  manager,
  investmentId,
  ...rest
}) => {
  const [cancelInvestmentModalIsOpen, setCancelInvestmentModalIsOpen] =
    useBoolean(false);
  const history = useHistory();

  const navigateToInvestmentWizard = () => {
    history.push(getInvestmentWizardRoute(investmentId as string));
  };

  return (
    <InvestmentCard
      manager={manager}
      imageHoverBottomLeft={
        <>
          {isDeletable && (
            <Flex p={"10px"} borderRadius={"6px"} alignItems="center">
              <IconButton
                isGhost
                p={0}
                onClick={setCancelInvestmentModalIsOpen.on}
              >
                <Trash2Icon w={4} color={"white"} />
              </IconButton>
              <CancelInvestmentModal
                investmentId={investmentId as string}
                onClose={() => {
                  refresh();
                  setCancelInvestmentModalIsOpen.off();
                }}
                isOpen={cancelInvestmentModalIsOpen}
              />
            </Flex>
          )}
        </>
      }
      actions={
        <Flex>
          <Button onClick={navigateToInvestmentWizard}>
            Continue investment
          </Button>
        </Flex>
      }
      {...rest}
    >
      {children}
    </InvestmentCard>
  );
};
